if (!customElements.get('popular-brands-section')) {
  class PopularBrandsSection extends HTMLElement {
    constructor() {
      super();
      this.tabs = this.querySelectorAll('[data-pb-tab]');
      this.panels = this.querySelectorAll('[data-pb-panel]');
      this.activeIndex = 0;
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.isVisible = false;
      this.isPaused = false;
    }

    connectedCallback() {
      if (this.tabs.length === 0) return;

      this.bindEvents();
      this.setActiveTab(0);
      this.setupIntersectionObserver();
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    bindEvents() {
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.onTabClick(index));

        // Listen for progress bar animation end (fires when ::before animation completes)
        tab.addEventListener('animationend', () => {
          if (tab.classList.contains('popular-brands__tab--active')) {
            this.advanceTab();
          }
        });
      });

      // Pause on hover over content area (desktop)
      const content = this.querySelector('.popular-brands__content');
      if (content) {
        content.addEventListener('mouseenter', () => this.pause());
        content.addEventListener('mouseleave', () => this.resume());
      }

      // Pause on hover over tabs
      const tabsRow = this.querySelector('.popular-brands__tabs');
      if (tabsRow) {
        tabsRow.addEventListener('mouseenter', () => this.pause());
        tabsRow.addEventListener('mouseleave', () => this.resume());
      }

    }

    setupIntersectionObserver() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.isVisible = entry.isIntersecting;
            if (this.isVisible && !this.isPaused) {
              this.dataset.paused = 'false';
            } else if (!this.isVisible) {
              this.dataset.paused = 'true';
            }
          });
        },
        { threshold: 0.2 }
      );
      this.observer.observe(this);
    }

    onTabClick(index) {
      if (index === this.activeIndex) return;
      this.setActiveTab(index);
    }

    setActiveTab(index) {
      // Update ARIA attributes and classes
      this.tabs.forEach((tab) => {
        tab.classList.remove('popular-brands__tab--active');
        tab.setAttribute('aria-selected', 'false');
      });

      this.panels.forEach((panel) => {
        panel.classList.remove('popular-brands__panel--active');
      });

      this.activeIndex = index;
      const activeTab = this.tabs[index];
      const activePanel = this.panels[index];

      if (activeTab) {
        // Force animation restart by triggering reflow
        activeTab.style.animation = 'none';
        activeTab.offsetHeight;
        activeTab.style.animation = '';
        activeTab.classList.add('popular-brands__tab--active');
        activeTab.setAttribute('aria-selected', 'true');
      }

      if (activePanel) {
        activePanel.classList.add('popular-brands__panel--active');
      }
    }

    advanceTab() {
      if (this.isPaused || !this.isVisible || this.prefersReducedMotion) return;

      const nextIndex = (this.activeIndex + 1) % this.tabs.length;
      this.setActiveTab(nextIndex);
    }

    pause() {
      this.isPaused = true;
      this.dataset.paused = 'true';
    }

    resume() {
      if (!this.isVisible) return;
      this.isPaused = false;
      this.dataset.paused = 'false';
    }
  }

  customElements.define('popular-brands-section', PopularBrandsSection);
}
